module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$v) ? _c('div', {
    staticClass: "wrapper--pageform"
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("สมัครสมาชิก / เข้าสู่ระบบ")]), _vm._v(" "), _c('div', {
    staticClass: "form__item--block"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form__text",
    attrs: {
      "id": "edit-email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.empty),
      expression: "$v.$errors.email.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล หรือ เบอร์โทรศัพท์")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.$errors.email.empty && _vm.$v.$errors.email.invalid),
      expression: "!$v.$errors.email.empty && $v.$errors.email.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล หรือ เบอร์โทรศัพท์ ให้ถูกต้อง")])]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form__text",
    attrs: {
      "id": "edit-password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password.empty),
      expression: "$v.$errors.password.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกรหัสผ่าน")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.password.minLength),
      expression: "$v.$errors.password.minLength"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("รหัสผ่านต้องยาวไม่น้อยกว่า 6 ตัวอักษร")])]), _vm._v(" "), _c('div', {
    staticClass: "button-actions"
  }, [_c('button', {
    staticClass: "btn btn-login-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))]), _vm._v(" "), _c('div', {
    staticClass: "text-center small"
  }, [_vm._v("หรือ")]), _vm._v(" "), _c('facebook-login', {
    staticClass: "fb-login",
    on: {
      "success": _vm.success
    }
  })], 1), _vm._v(" "), (_vm.backButton) ? _c('a', {
    staticClass: "fl-left btn-link btn-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.backButtonText))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "fl-right btn-link btn-forgot",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.gotoForgot($event)
      }
    }
  }, [_vm._v("ลืมรหัสผ่าน?")])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "edit-email"
    }
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon/mail@2x.png"),
      "width": "25px"
    }
  })]), _vm._v("\n      อีเมล หรือ เบอร์โทรศัพท์\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "edit-password"
    }
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icon/password@2x.png"),
      "width": "25px"
    }
  })]), _vm._v("รหัสผ่าน")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e1583bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageRegisterForm.vue
// module id = 723
// module chunks = 1